import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // login: getUserLogin() // 用户名
    },
    mutations: {
        // SET_LOGIN: (state, login) => {
        //     state.login = login
        // }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js